import React, { useState, useEffect } from 'react'

import { withRouter } from 'react-router-dom'
import { injectIntl, FormattedMessage } from 'react-intl'
import ReactTooltip from 'react-tooltip'
import moment from 'moment'

import { DateMapper } from '../../components/common/dateMapper/DateMapper'
import LoadingSpinner from '../../components/common/spinner/LoadingSpinner'
import MessageFeedback from '../../components/common/messageFeedback/MessageFeedback'
import Icon from '../../components/common/icon/Icon'
import Tooltip from '../../components/common/tooltip/Tooltip'
import EmptyState from '../../components/common/emptyState/EmptyState'
import DataTable from '../../components/common/dataTable/DataTable'
import DataTableHeader from '../../components/common/dataTable/DataTableHeader'
import DataTableRow from '../../components/common/dataTable/DataTableRow'
import DataTableCol from '../../components/common/dataTable/DataTableCol'
import DataTableHeaderCol from '../../components/common/dataTable/DataTableHeaderCol'
import Personalization from '../../components/common/personalization/Personalization'
import InputContainer from '../../components/common/inputContainer/InputContainer'
import Chosen from '../../components/common/chosen/Chosen'
import Button from '../../components/common/button/Button'
import MessageNoResult from '../../components/common/messageNoResult/MessageNoResult'
import Pager from '../../components/common/pager/Pager'
import OrderGrid from '../../components/common/dataTable/OrderGrid'
import SingleLoader from '../../components/common/singleLoader/SingleLoader'
import MessageBox from '../../components/common/messageBox/MessageBox'

import { getEmailMessages, getEmailSendings } from '../../api/beSendApi/BeSendApi'
import { getMessageDetails } from '../../api/beEmailMessageApi/BeEmailMessageApi'
import { getListDataById } from '../../api/beListApi/BeListApi'
import { getMessageTotalCounters, getMessageRecipientsTotalCounters } from '../../api/statisticsApi/StatisticsApi'
import { getGroups, getRecipientEmail } from '../../api/beRecipientApi/BeRecipientApi'
import { getAccountDataRetention } from '../../api/beAccount/BeAccount'
import { msgInChosenLimit } from '../../services/Constants'
import batchPromises from '../../services/batchPromises'

const PAGE_STATUS_READY = 'PAGE_STATUS_READY'
const PAGE_STATUS_ERROR = 'PAGE_STATUS_ERROR'
const PAGE_STATUS_PARAMS_ERROR = 'PAGE_STATUS_PARAMS_ERROR'
const PAGE_STATUS_LOADING = 'PAGE_STATUS_LOADING'

const initialPageState = {
  pageStatus: PAGE_STATUS_LOADING,
  loadPage: true,
  statDeleted: undefined,
  noData: false,
  emptyState: false,
  pageNumber: 1,
  totalItems: null,
  pageSize: 10,
  orderBy: 'OrderbyLastOpening',
  orderDescending: true,
  loadData: false
}

const initialSearch = {
  email: '',
  groups: undefined,
  activity: ''
}

const initialGroupChosen = {
  limit: false,
  loading: true
}

let timeZoneCode = ''
let retentionDays

// http://localhost:1234/frontend/userviewreport/listGuid/CACD7F73-2EFC-45CE-9600-913CC7D5CA99/idList/1/idNL/8
// https://d4f0b.smtpnext.com/frontend/userviewreport/listGuid/B16D2BFC-4A0B-4BFD-8614-C67FDF30D157/idList/1/idNL/8
// https:/d4f0b.smtpnext.com/frontend/userviewreport/listGuid/CACD7F73-2EFC-45CE-9600-913CC7D5CA99/idList/1/idNL/8

// VECCHIO

const UserViewReport = ({ match, history, location, intl }) => {
  const [pageState, setPageState] = useState(initialPageState)
  const [msgData, setMsgData] = useState({})
  const [search, setSearch] = useState(initialSearch)
  const [groupsChosen, setGroupsChosen] = useState(initialGroupChosen)
  // const [groupSelected, setGroupSelected] = useState({})
  const [groupsChosenOptions, setGroupsChosenOptions] = useState([])
  const [groupsChosenSearchInitial, setGroupsChosenSearchInitial] = useState([])
  const [data, setData] = useState([])
  const [availableRecipients, setAvailableRecipients] = useState(undefined)
  const [listName, setListName] = useState('')
  const [recipientDaysAvailable, setRecipientDaysAvailable] = useState(null)

  function convertDateUtctoCTZ (dateString) {
    const dateInstance = new Date(dateString)
    // const tmp = new Date(dateInstance.getTime() + dateInstance.getTimezoneOffset() * 60000)

    return DateMapper.toLocalDate(dateInstance, timeZoneCode)
  }

  // const isNanOrUndefined = function (value) {
  //   if (value === '-') return false
  //   if (value === null) return true
  //   if (isNaN(value)) return true
  //   if (value === undefined) return true
  //   return false
  // }

  const chosenFilterByActivity = [{
    label: '',
    options: [{
      value: ' ', label: intl.formatMessage({ id: 'Load.Statistics.AllActivity' })
    }]
  },
  {
    label: intl.formatMessage({ id: 'Load.SearchRecipients.ActivityFilter' }),
    options: [{
      value: 'ActivityFilterOpened', label: intl.formatMessage({ id: 'Load.Statistics.ActivityFilterOpened' })
    }, {
      value: 'ActivityFilterNotOpened', label: intl.formatMessage({ id: 'Load.Statistics.ActivityFilterNotOpened' })
    }, {
      value: 'ActivityFilterClicked', label: intl.formatMessage({ id: 'Load.Statistics.ActivityFilterClicked' })
    }, {
      value: 'ActivityFilterOpenedNotClicked', label: intl.formatMessage({ id: 'Load.Statistics.ActivityFilterOpenedNotClicked' })
    }, {
      value: 'ActivityFilterSuccessfullySent', label: intl.formatMessage({ id: 'Load.Statistics.ActivityFilterSuccessfullySent' })
    }, {
      value: 'ActivityFilterBounced', label: intl.formatMessage({ id: 'Load.Statistics.ActivityFilterBounced' })
    }, {
      value: 'ActivityFilterNoImage', label: intl.formatMessage({ id: 'Load.Statistics.ActivityFilterNoImage' })
    }]
  }, {
    label: intl.formatMessage({ id: 'Load.Statistics.ManageRecDettaglioNonRaggiungibili' }),
    options: [{
      value: 'ActivityFilterBouncedWA', label: intl.formatMessage({ id: 'Load.Statistics.ActivityFilterBouncedWA' })
    }, {
      value: 'ActivityFilterBouncedFULL', label: intl.formatMessage({ id: 'Load.Statistics.ActivityFilterBouncedFULL' })
    }, {
      value: 'ActivityFilterBouncedTEMP', label: intl.formatMessage({ id: 'Load.Statistics.ActivityFilterBouncedTEMP' })
    }, {
      value: 'ActivityFilterBouncedBLK', label: intl.formatMessage({ id: 'Load.Statistics.ActivityFilterBouncedBLK' })
    }, {
      value: 'ActivityFilterBouncedOTHER', label: intl.formatMessage({ id: 'Load.Statistics.ActivityFilterBouncedOTHER' })
    }]
  }]

  // on render
  useEffect(() => {
    ReactTooltip.rebuild()
  })

  //  on mount
  useEffect(() => {
    reloadPage()

    // on unmount
    return () => { ReactTooltip.rebuild() }
  }, [])

  const listGuid = match.params.listGuid
  const idList = parseInt(match.params.idList)
  const idMessage = parseInt(match.params.idNL)

  useEffect(() => {
    if (pageState.loadPage) {
      setPageState((prevState) => ({ ...prevState, loadPage: false }))

      const search = {
        IdMessages: [idMessage],
        Completed: true
      }
      const types = ['EI']

      Promise.all([
        getEmailMessages(idList, listGuid, search, 1, 1, false),
        getAccountDataRetention(idList, listGuid),
        getListDataById(idList, listGuid)
      ]).then(([emailMessages, accountDataRetention, listData]) => {
        if (emailMessages.TotalItems > 0) {
          timeZoneCode = listData.TimeZoneCode

          retentionDays = (accountDataRetention > 365) ? 365 : accountDataRetention
          setListName(listData.Name)
          setPageState((prevState) => ({ ...prevState, statDeleted: false }))
          Promise.all([
            getEmailSendings(idList, listGuid, search, 1, 1, false),
            getEmailSendings(idList, listGuid, search, 1, 1, true),
            getMessageDetails(idList, listGuid, idMessage, false),
            getMessageTotalCounters(idList, listGuid, idMessage, types, '', ''),
            getGroups(idList, listGuid, '', msgInChosenLimit, 1, 'Id', true),
            getMessageRecipientsTotalCounters(idList, listGuid, idMessage, 0, 1, '', null, null, '', '', false, '', '')

          ]).then(([dateLastSendResp, dateFirstSendResp, msg, totalCounters, groups, availableTotalCounter]) => {
            setMsgData({
              Subject: msg.Subject,
              Notes: msg.Notes ? 'ID ' + idMessage + ' - ' + msg.Notes : 'ID ' + idMessage,
              DateLastSend: (dateLastSendResp && (dateLastSendResp.Items.length > 0)) ? DateMapper.datetimeToSTring(convertDateUtctoCTZ(dateLastSendResp.Items[0].StartDateJs)) : '-',
              DateFirstSend: (dateFirstSendResp && (dateFirstSendResp.Items.length > 0)) ? DateMapper.datetimeToSTring(convertDateUtctoCTZ(dateFirstSendResp.Items[0].StartDateJs)) : '-',
              DateLastSendObj: (dateLastSendResp && (dateLastSendResp.Items.length > 0)) ? convertDateUtctoCTZ(dateLastSendResp.Items[0].StartDateJs) : null,
              DateFirsSendObj: (dateFirstSendResp && (dateFirstSendResp.Items.length > 0)) ? convertDateUtctoCTZ(dateFirstSendResp.Items[0].StartDateJs) : null,
              Recipients: totalCounters.EI
            })

            if (dateLastSendResp && (dateLastSendResp.Items.length > 0)) {
              const diffTime = Math.abs(moment.utc() - convertDateUtctoCTZ(dateLastSendResp.Items[0].StartDateJs))
              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
              setRecipientDaysAvailable(retentionDays - diffDays)
            } else {
              setRecipientDaysAvailable('-')
            }

            setAvailableRecipients(availableTotalCounter.TotalItems)

            if (groups.TotalItems > msgInChosenLimit) {
              setGroupsChosen((prevState) => ({ ...prevState, limit: true }))
            }
            const tmpGroupsSearch = groups.Items.map((g) => {
              return {
                value: g.Id,
                label: `${g.Id} - ${g.Name}`
              }
            })
            tmpGroupsSearch.unshift({ value: 0, label: intl.formatMessage({ id: 'Load.Filters.NoGroupOption' }) })
            tmpGroupsSearch.unshift({ label: intl.formatMessage({ id: 'Load.Statistics.LinkDetailSearchPlaceholder' }), value: -1 })
            setGroupsChosen((prevState) => ({ ...prevState, loading: false }))
            setGroupsChosenOptions(tmpGroupsSearch)
            setGroupsChosenSearchInitial(tmpGroupsSearch)

            setPageState((prevState) => ({ ...prevState, loadData: true, pageStatus: PAGE_STATUS_READY }))
          })
        } else {
          setPageState((prevState) => ({ ...prevState, statDeleted: true, pageStatus: PAGE_STATUS_READY }))
        }
      }).catch(() => {
        setPageState((prevState) => ({ ...prevState, statDeleted: false, pageStatus: PAGE_STATUS_ERROR }))
      })

      // setPageState((prevState) => ({ ...prevState, pageStatus: PAGE_STATUS_READY }))
    }
  }, [pageState.loadPage])

  function handleInputChangeChosenGroupSearch (val) {
    if (val) {
      setGroupsChosen((prevState) => ({ ...prevState, loading: true }))

      getGroups(idList, listGuid, val, msgInChosenLimit, 1, 'Id', true)
        .then((groups) => {
          if (groups.TotalItems > msgInChosenLimit) {
            setGroupsChosen((prevState) => ({ ...prevState, limit: true }))
          }

          const newGroups = groups.Items.map((g) => {
            return {
              value: g.Id,
              label: `${g.Id} - ${g.Name}`
            }
          })
          newGroups.unshift({ label: intl.formatMessage({ id: 'Load.Filters.NoGroupOption' }), value: 0 })
          newGroups.unshift({ label: intl.formatMessage({ id: 'Load.Statistics.LinkDetailSearchPlaceholder' }), value: -1 })

          setGroupsChosenOptions(newGroups)
        })
        .catch(() => {
          setPageState((prevState) => ({ ...prevState, statDeleted: false, pageStatus: PAGE_STATUS_ERROR }))
        })
        .finally(() => {
          setGroupsChosen((prevState) => ({ ...prevState, loading: false }))
        })
    } else {
      setGroupsChosen((prevState) => ({ ...prevState, loading: false }))
      setGroupsChosenOptions(groupsChosenSearchInitial)
      // const idx = groupsChosenSearchInitial.findIndex((o) => ((groupSelected) && (o.value === groupSelected)))
      // if (idx === -1 && groupSelected !== undefined && groupSelected !== null) {
      //   setGroupsChosenOptions([groupSelected, ...groupsChosenSearchInitial])
      // } else {
      //   setGroupsChosenOptions(groupsChosenSearchInitial)
      // }
    }
  }

  useEffect(() => {
    if (pageState.loadData) {
      const dateFrom = DateMapper.datetimeSecondToString(moment.utc().add(-parseInt(retentionDays), 'days').toDate())

      getMessageRecipientsTotalCounters(idList, listGuid, idMessage, pageState.pageSize, pageState.pageNumber, search.email, search.groups >= 0 ? search.groups : null, null, search.activity,
        pageState.orderBy, pageState.orderDescending, dateFrom, '')
        .then((res) => {
          setPageState((prevState) => ({ ...prevState, statDeleted: false, pageStatus: PAGE_STATUS_READY, totalItems: res.TotalItems }))

          if (res.TotalItems === 0) {
            if (JSON.stringify(search) === JSON.stringify(initialSearch)) {
              setPageState((prevState) => ({ ...prevState, emptyState: true, noData: false, loadData: false }))
            } else {
              setPageState((prevState) => ({ ...prevState, emptyState: false, noData: true, loadData: false }))
            }
          } else {
            const resData = res.RecipientCounters.map((o) => ({
              ...o,
              OpeningStats: { ...o.OpeningStats, LastActionDate: DateMapper.datetimeToSTring(convertDateUtctoCTZ(o.OpeningStats.LastActionDateJs)) }
            }))

            setData(resData)
            setPageState((prevState) => ({ ...prevState, emptyState: false, noData: false, loadData: false }))

            const idRecipients = resData.map((rec) => rec.IdRecipient)
            batchPromises(idRecipients, 10, getRecipientInfo).then((batchResult) => {})
          }
        })
        .catch(() => {
          setPageState((prevState) => ({ ...prevState, statDeleted: false, pageStatus: PAGE_STATUS_ERROR, loadData: false }))
        })
      // idmessage, pagesize, pagenumber, search, group, idrecipient, filter, orderby, orderdescending, dateFromUTC, dateToUTC
    }
  }, [pageState.loadData])

  // useEffect(() => {
  //   if (data.length > 0) {

  //     })
  //   }
  // }, [data])

  function getRecipientInfo (idRecipient) {
    if (idRecipient) {
      return getRecipientEmail(idList, listGuid, idRecipient)
        .then((resp) => {
          setData((prevState) => (
            prevState.map((o) => ((o.IdRecipient === idRecipient) ? { ...o, Email: resp } : o))
          ))
          return idRecipient
        })
        .catch(() => {
          setData((prevState) => (
            prevState.map((o) => ((o.IdRecipient === idRecipient) ? { ...o, Email: <Icon family='fa' icon='exclamation-triangle' tooltipText={intl.formatMessage({ id: 'Load.Common.LoadDataError' })} className='text-light' /> } : o))
          ))
          return idRecipient
        })
    } else {
      const noTrackedRecipient = (<em><FormattedMessage id='Load.Statistics.NoTrackedRecipient' /></em>)
      setData((prevState) => (
        prevState.map((o) => ((o.IdRecipient === idRecipient) ? { ...o, Email: noTrackedRecipient } : o))
      ))
      // return idRecipient
      return idRecipient
    }
  }

  const propStatDelted = {
    title: intl.formatMessage({ id: 'Load.Statistics.DeletingStatsTitle' }),
    description: intl.formatMessage({ id: 'Load.Statistics.DeletingStatsDescription' })
  }

  const personalizationProps = {
    idList: idList,
    showLogo: true,
    applyCustomCSS: true
  }

  const propsInputSearch = {
    value: search.email,
    type: 'text',
    placeholder: intl.formatMessage({ id: 'Load.Statistics.RecipientListSearchPlaceholder' }),
    onChange: onChangeInputSearch,
    enablePressEnter: true,
    pressEnterCallback: onClickSearch,
    className: 'test-statManagerRecipientPubb-searchEmail'
  }

  const propsChosenGroup = {
    value: search.groups,
    isSearchable: true,
    onChange: onChangeChosenGroup,
    options: groupsChosenOptions,
    placeholder: intl.formatMessage({ id: 'Load.Statistics.LinkDetailSearchPlaceholder' }),
    limitSearch: groupsChosen.limit && !groupsChosen.loading,
    limitSearchText: intl.formatMessage({ id: 'Load.Filters.ActivityMessagesMoreResults' }),
    onInputChange: handleInputChangeChosenGroupSearch,
    filterOptionMethod: 'contains',
    isLoading: groupsChosen.loading,
    className: 'test-statManagerRecipientPubb-searchgroup'
  }

  const propsChosenFilterByActivity = {
    value: search.activity,
    isSearchable: true,
    onChange: onChangeChosenActivity,
    options: chosenFilterByActivity,
    placeholder: intl.formatMessage({ id: 'Load.Statistics.FilterByActivity' }),
    className: 'test-statManagerRecipientPubb-searchActivity'

  }

  const propsBtnCancel = {
    children: intl.formatMessage({ id: 'Load.MailupCommon.Cancel' }),
    kind: 'secondary',
    onClick: onClickResetSearch,
    className: 'test-statManagerRecipientPubb-resetSerach'
  }

  const propsBtnSearch = {
    children: intl.formatMessage({ id: 'Load.MailupCommon.SearchButton' }),
    kind: 'secondary',
    onClick: onClickSearch,
    className: 'test-statManagerRecipientPubb-clicSerach'
  }

  const propsMessageNoResult = {
    text: intl.formatMessage({ id: 'Load.Common.NoData' })
  }

  const propsPager = {
    currentPage: pageState.pageNumber,
    itemsPerPage: pageState.pageSize,
    totalItems: pageState.totalItems,
    onChange: onChangePager,
    ofLabel: intl.formatMessage({ id: 'Load.Pager.Of' }),
    itemsLabel: intl.formatMessage({ id: 'Load.Pager.Items' }),
    className: 'test-statManagerRecipientPubb-paging'
  }

  const loaderProps = {
    height: '465px'
  }

  function onChangePager (val) {
    setPageState((prevState) => ({ ...prevState, pageNumber: val.pageNumber, pageSize: val.pageSize, loadData: true }))
  }

  function onClickResetSearch () {
    setSearch(initialSearch)
    setPageState((prevState) => ({ ...initialPageState, pageNumber: 1, pageSize: 10, loadData: true, laodPage: false }))
  }

  function onClickSearch () {
    setPageState((prevState) => ({ ...prevState, pageNumber: 1, loadData: true }))
  }

  function onChangeChosenGroup (e) {
    if (groupsChosenSearchInitial.filter((o) => o.value === e.value).length > 0) {
      setGroupsChosenOptions(groupsChosenSearchInitial)
    } else {
      setGroupsChosenOptions([e, ...groupsChosenSearchInitial])
    }
    setSearch({ ...search, groups: e.value })
    // setGroupSelected(e)
  }

  function onChangeInputSearch (e) {
    setSearch({ ...search, email: e.target.value })
  }

  function onChangeChosenActivity (e) {
    setSearch({ ...search, activity: e.value.trim() })
  }

  function reloadPage () {
    setPageState((prevState) => ({ ...initialPageState, pageStatus: PAGE_STATUS_LOADING }))
  }

  function setOrder (v) {
    setPageState((prevState) => ({ ...prevState, orderBy: v, orderDescending: !prevState.orderDescending, loadData: true }))
  }

  return (
    <div className='frontend-wrapper-xl'>

      {(pageState.pageStatus === PAGE_STATUS_LOADING) &&
        <LoadingSpinner />}

      {(pageState.pageStatus === PAGE_STATUS_PARAMS_ERROR) &&
        <MessageFeedback kind='error'>{intl.formatMessage({ id: 'Load.Statistics.ErrorDisplayingReport' })}</MessageFeedback>}

      {(pageState.pageStatus === PAGE_STATUS_ERROR) &&
        <MessageFeedback kind='error'>
          {intl.formatMessage({ id: 'Load.Statistics.ErrorLoadingData' })}
          <a className='frontend-p-left-xs-thin' onClick={reloadPage}>{intl.formatMessage({ id: 'Load.MailupCommon.ReloadData' })}</a>
        </MessageFeedback>}

      {pageState.statDeleted === true
        ? <>
          <Personalization {...personalizationProps} />
          <EmptyState {...propStatDelted} />
          </>
        : <>
          {(pageState.pageStatus === PAGE_STATUS_READY) && <>
            <Personalization {...personalizationProps} />
            <Tooltip />
            <div className='frontend-row frontend-row_reset row-flex'>
              <h1><b>{intl.formatMessage({ id: 'Load.BounceFrontend.RecipientsReport' })}</b></h1>
            </div>

            <div className='frontend-row frontend-row_reset'>
              <div className='col-xs-8 frontend-p-left-0'>
                <div className='frontend-box frontend-p-bottom'>
                  <h3 className='frontend-m-bottom-x-sm'><b>{intl.formatMessage({ id: 'Load.Statistics.MsgDett' })}</b></h3>
                  <p className='frontend-m-bottom-xx-sm'><strong>{msgData.Subject}</strong></p>
                  <p className='frontend-m-bottom-x-sm'>{msgData.Notes}</p>
                  <p className='frontend-m-bottom-x-sm'>
                    <b>{intl.formatMessage({ id: 'Load.MailupCommon.List' })}:</b>&nbsp;
                    <span>{idList} - {listName}</span>
                  </p>
                  <p className='frontend-m-bottom-xx-sm'>
                    <b>{intl.formatMessage({ id: 'Load.Statistics.FirstSend' })}:</b>&nbsp;
                    <span>{msgData.DateFirstSend} {timeZoneCode.split(':')[0]}</span>
                  </p>
                  <p className='frontend-m-bottom-xx-sm'>
                    <b>{intl.formatMessage({ id: 'Load.Statistics.LastSend' })}:</b>&nbsp;
                    <span>{msgData.DateLastSend} {timeZoneCode.split(':')[0]}</span>
                  </p>

                </div>
              </div>
              <div className='col-xs-4 frontend-p-right-0'>
                <div className='frontend-box frontend-p-bottom'>
                  <h2><b>{intl.formatNumber(msgData.Recipients)}</b></h2>
                  <p className='frontend-text-uppercase frontend-note'>{intl.formatMessage({ id: 'Load.Statistics.SelectedRecipients' })}</p>
                </div>
              </div>
            </div>
            {pageState.emptyState ? <>
              <div className='frontend-box frontend-p-bottom'>
                <em className='text-center'>
                  {intl.formatMessage({ id: 'Load.Statistics.EmptyStateWithDataRetention' }, { x: retentionDays })}
                </em>

              </div>
            </>
              : <>
                <div className='frontend-row-reset frontend-p-bottom-xs-thin'>
                  <h2 className='d-inline-block'>
                    <span>{intl.formatMessage({ id: 'Load.Statistics.RecipientStats' })}</span>
                    <b className=''> {intl.formatNumber(availableRecipients)}</b>&nbsp;
                    {intl.formatMessage({ id: 'Load.Statistics.RecipientStatsRecipients' })}
                  </h2>
                  <Icon family='sli' icon='question' className='note frontend-p-left-xs-thin' tooltipText={intl.formatMessage({ id: 'Load.Statistics.TooltipDataAvailability' })} />
                </div>
                <div className='frontend-row frontend-row-reset frontend-p-bottom'>
                  {/* <pre>{JSON.stringify(groupsChosen.options)}</pre> */}
                  <div className='col-xs-4 frontend-p-left-0'>
                    <InputContainer {...propsInputSearch} />
                  </div>
                  <div className='col-xs-3'>

                    <Chosen {...propsChosenGroup} />
                  </div>
                  <div className='col-xs-3'>
                    <Chosen {...propsChosenFilterByActivity} />
                  </div>
                  <div className='col-xs-1 frontend-p-right-0'>
                    <Button {...propsBtnCancel} />
                  </div>
                  <div className='col-xs-1 frontend-p-right-0'>
                    <Button {...propsBtnSearch} />
                  </div>
                </div>
                <div className='frontend-row frontend-row-reset frontend-m-bottom'>
                  {/*  */}
                  <div className='frontend-box'>
                    {pageState.loadData ? <SingleLoader {...loaderProps} />
                      : <>
                        <div className='frontend-row-reset frontend-p-bottom-xs-thin'>
                          <h3 className='d-inline-block'>
                            <span className=''>{intl.formatMessage({ id: 'Load.Common.SearchResults' })}</span>
                            <b className=''> {intl.formatNumber(pageState.totalItems)}</b>
                            <span className='' />

                          </h3>
                            /{intl.formatNumber(availableRecipients)}
                          <Icon family='sli' icon='question' className='note frontend-p-left-xs-thin' tooltipText={intl.formatMessage({ id: 'Load.Statistics.RecipientsRetentionTooltip' })} />

                        </div>
                        {(pageState.noData)
                          ? <MessageNoResult className='frontend-m-bottom frontend-m-top-x-sm' {...propsMessageNoResult} />
                          : <>
                            <DataTable>
                              <DataTableHeader>

                                <DataTableHeaderCol width='5'>
                                  {intl.formatMessage({ id: 'Load.Statistics.Recipient' })}
                                </DataTableHeaderCol>
                                <DataTableHeaderCol width='3' className='frontend-text-right'>
                                  {intl.formatMessage({ id: 'Load.Statistics.LastOpeningDate' })}&nbsp;
                                  <OrderGrid data='OrderbyLastOpening' callback={setOrder} isActive={pageState.orderBy === 'OrderbyLastOpening'} className='test-statManageRecipientReport-OrderbyLastOpening' />

                                </DataTableHeaderCol>
                                <DataTableHeaderCol width='2' className='frontend-text-right'>
                                  {intl.formatMessage({ id: 'Load.Statistics.TotalOpenings' })}&nbsp;
                                  <OrderGrid data='OrderbyAT' callback={setOrder} isActive={pageState.orderBy === 'OrderbyAT'} className='test-statManageRecipientReport-OrderbyLastOpening' />

                                </DataTableHeaderCol>
                                <DataTableHeaderCol width='2' className='frontend-text-right'>
                                  {intl.formatMessage({ id: 'Load.Common.TotalClicks' })}&nbsp;
                                  <OrderGrid data='OrderbyCT' callback={setOrder} isActive={pageState.orderBy === 'OrderbyCT'} className='test-statManageRecipientReport-OrderbyLastOpening' />

                                </DataTableHeaderCol>
                              </DataTableHeader>
                              {data.map((item, index) =>
                                <DataTableRow key={index}>

                                  <DataTableCol width='5'>
                                    {item.Email && <p>{item.Email}</p>}
                                    {!item.Email && <p className='is-loading' />}
                                  </DataTableCol>
                                  <DataTableCol width='3' className='frontend-text-right'>
                                    {item.OpeningStats.TotalCounter > 0 && <p>{item.OpeningStats.LastActionDate} {timeZoneCode.split(':')[0]}</p>}
                                    {item.OpeningStats.TotalCounter === 0 && <p>-</p>}
                                  </DataTableCol>
                                  <DataTableCol width='2' className='frontend-text-right'>  <p className='text-light'>{intl.formatNumber(item.OpeningStats.TotalCounter)}</p></DataTableCol>
                                  <DataTableCol width='2' className='frontend-text-right'> <p className='text-light'>{intl.formatNumber(item.ClickStats.TotalCounter)}</p></DataTableCol>

                                </DataTableRow>
                              )}
                            </DataTable>
                            <Pager {...propsPager} />

                          </>}
                      </>}
                  </div>

                </div>
                <div className='frontend-row frontend-row_reset'>
                  <div className='col-xs-12 frontend-p-left-0 frontend-p-right-0'>
                    <MessageBox type='tip' className='m-bottom-0' title={intl.formatMessage({ id: 'Load.Statistics.TitleDataAvailability' }, { x: recipientDaysAvailable })}>
                      {intl.formatMessage({ id: 'Load.Statistics.DescrDataAvailability' }, { x: retentionDays })}
                    </MessageBox>
                  </div>
                </div>
                </>}

                                                           </>}

        </>}

    </div>
  )
}

export default injectIntl(withRouter(UserViewReport))
